<script>
  export let row = {};
</script>

<span class:overage={row.signature_delta > 0}>
  {row.signature_delta > 0 ? '-' : ''}{row.signature_delta}
</span>

<style lang="scss">
  .overage {
    background-color: var(--color-red-0);
    border-radius: var(--border-radius-base);
    color: var(--color-red-400);
    font-weight: var(--font-weight-medium);
    padding: var(--padding-small);
  }
</style>
